import React from "react";

import FormContainer from "../../../../../../Components/FormContainer/FormContainer";
import SelectInput from "../../../../../../Components/SelectInput/SelectInput";
import RadioInput from "../../../../../../Components/RadioInput/RadioInput";
import InputErrorMessage from "../../../../../../Components/InputErrorMessage/InputErrorMessage";
import Industries from "../../../../../../Data/Industries";
import IndustryMatchImportance from "../../../../../../Data/IndustryMatchImportance";
import Revenue from "../../../../../../Data/Revenue";
import BusinessGoal from "../../../../../../Data/BusinessGoal";
import GoalMatchImportance from "../../../../../../Data/GoalMatchImportance";
import RevenueMatchImportance from "../../../../../../Data/RevenueMatchImportance";
import TimeSetter from "../../../../../../Components/TimeSetter/TimeSetter";
import TimeSlotHandler from "../../../../../../Components/TimeSlotsHandler/TimeSlotHandler";
import TextInput from "../../../../../../Components/TextInput/TextInput";
import PrimaryButton from "../../../../../../Components/PrimaryButton/PrimaryButton";
import MultiSelectCheckbox from "../../../../../../Components/MultiselectCheckbox/MultiSelectCheckbox";
import { withRouter } from "react-router-dom";
import call from "../../../../../../API/API";

import "./MatchingForm.css";
class MatchingForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      meetingDaysError: "",
      convertedRevenue: "",
      matching_criteria: {
        industry: [],
        industry_importance: "",
        revenue_range: {
          min: 0,
          max: 0,
        },
        match_comparable_revenues: "",
        meeting_days: [],
        nearest_business_goal: "",
        growth_goal_match: "",
        account_links: {
          meeting_scheduler: "",
          linkedin: "",
          company_website: "",
        },
      },
      showIndustrySaveButton: false,
      showRevenueSaveButton: false,
      showAvailabilitySaveButton: false,
      showAccountLinksSaveButton: false,
      formError: "",
    };

    this.convertRevenue = this.convertRevenue.bind(this);
    this.handleOnIndustryChange = this.handleOnIndustryChange.bind(this);
    this.handleIndustryImportanceOnChange = this.handleIndustryImportanceOnChange.bind(
      this
    );
    this.handleRevenueOnChange = this.handleRevenueOnChange.bind(this);
    this.hanldeOnBusinessGoalChange = this.hanldeOnBusinessGoalChange.bind(
      this
    );
    this.handleOnBusinessGoalImportanceChange = this.handleOnBusinessGoalImportanceChange.bind(
      this
    );
    this.handleRevenueImportanceOnChange = this.handleRevenueImportanceOnChange.bind(
      this
    );
    this.handleTimeSlotOnChange = this.handleTimeSlotOnChange.bind(this);
    this.handleDeleteTimeSlot = this.handleDeleteTimeSlot.bind(this);
    this.handleAddingTimeSlot = this.handleAddingTimeSlot.bind(this);
    this.handleMeetingSchedulerOnChange = this.handleMeetingSchedulerOnChange.bind(
      this
    );
    this.handleLinkedInOnChange = this.handleLinkedInOnChange.bind(this);
    this.handleWebsiteOnChange = this.handleWebsiteOnChange.bind(this);
    this.handleSaveMatchingChanges = this.handleSaveMatchingChanges.bind(this);
  }

  // this.setState({
  //     matching_criteria: userInfo.results.matching_data,
  //     old_matching_criteria: userInfo.results.matching_data,
  //     convertedRevenue: this.convertRevenue(userInfo.results.matching_data.revenue_range.min)
  //     })

  componentDidMount() {
    call.users_API
      .getPersonalUserMatchingCriteria()
      .then((result) => {
        if (result.success) {
          let matching_data = result.results.matching_data;
          if (matching_data && matching_data.revenue_range.min) {
            this.setState({
              matching_criteria: matching_data,
              convertedRevenue: this.convertRevenue(
                matching_data.revenue_range.min
              ),
            });
          }
        } else {
          this.props.history.push("/error", { error: result.results });
        }
      })
      .catch((err) => {
        this.props.history.push("/error", { error: err.message });
      });
  }

  // componentDidMount() {
  //     call.users_API.getPersonalUserMatchingCriteria()
  //     .then((response) => {
  //         if(response.success) {
  //             let matching_data = response.results.matching_data;
  //             if(matching_data && matching_data.revenue_range.min) {
  //                 this.setState({
  //                     matching_criteria: matching_data,
  //                     old_matching_criteria: matching_data,
  //                     convertedRevenue: this.convertRevenue(matching_data.revenue_range.min)
  //                 })
  //             } else {
  //                 let default_matching_criteria = {
  //                     industry: 'Aerospace',
  //                     industry_importance: false,
  //                     revenue_range: {
  //                         min: 0,
  //                         max: 0
  //                     },
  //                     match_comparable_revenues: false,
  //                     meeting_days: [],
  //                     nearest_business_goal: 1,
  //                     account_links: {
  //                         meeting_scheduler: '',
  //                         linkedin: '',
  //                         company_website: ''
  //                     }
  //                 }
  //                 call.matching_criteria_API.createMatchingCriteria(default_matching_criteria)
  //                 .then(response => {
  //                     if(response.success) {
  //                         console.log('matching-criteria-default-success')
  //                     } else {
  //                         this.props.history.push('/error', {error: response.results})
  //                     }
  //                 })
  //                 .catch(err => {
  //                     this.props.history.push('/error', {error: err.message})
  //                 })
  //             }
  //         } else {
  //             this.props.history.push('/error', {error: response.results})
  //         }
  //     })
  //     .catch(err => {
  //         this.props.history.push('/error', {error: err.message})
  //     })
  // }

  convertRevenue(minRevenue) {
    let convertedRevenue = Revenue.find(
      (d) => d.backendValue.min === minRevenue
    );
    if (convertedRevenue) {
      return convertedRevenue.value;
    } else {
      return "";
    }
  }

  //updated
  handleOnIndustryChange(e) {
    const checkedValues = [...this.state.matching_criteria.industry];
    const value = e.target.value;
    if (e.target.checked) {
      const index = checkedValues.indexOf(value);
      if (index > -1) {
        checkedValues.splice(index, 1);
      }
    } else {
      checkedValues.push(e.target.value);
    }

    //Reorder
    const orderedCheckedValues = [];
    Industries.forEach((industry) => {
      const result = checkedValues.find((value) => value === industry.value);
      if (result) {
        orderedCheckedValues.push(industry.value);
      } else {
        return;
      }
    });

    this.setState((prevState) => ({
      matching_criteria: {
        ...prevState.matching_criteria,
        industry: orderedCheckedValues,
      },
    }));
  }

  //updated
  handleIndustryImportanceOnChange(value) {
    this.setState((prevState) => ({
      matching_criteria: {
        ...prevState.matching_criteria,
        industry_importance: value,
      },
    }));
  }

  //updated
  handleRevenueOnChange(value) {
    let convertedRevenue = this.convertRevenue(value.min);
    this.setState((prevState) => ({
      convertedRevenue: convertedRevenue,
      matching_criteria: {
        ...prevState.matching_criteria,
        revenue_range: value,
      },
    }));
  }

  hanldeOnBusinessGoalChange(value) {
    this.setState((prevState) => ({
      matching_criteria: {
        ...prevState.matching_criteria,
        nearest_business_goal: value,
      },
    }));
  }

  //updated
  handleRevenueImportanceOnChange(value) {
    this.setState((prevState) => ({
      matching_criteria: {
        ...prevState.matching_criteria,
        match_comparable_revenues: value,
      },
    }));
  }

  handleOnBusinessGoalImportanceChange(value) {
    this.setState((prevState) => ({
      matching_criteria: {
        ...prevState.matching_criteria,
        growth_goal_match: value,
      },
    }));
  }

  //updated
  handleAddingTimeSlot(value) {
    let meetingDays = [...this.state.matching_criteria.meeting_days];
    if (meetingDays.length > 5) {
      this.setState({
        meetingDaysError: "You have reached maximum number of time slots",
      });
    } else {
      this.setState((prevState) => ({
        matching_criteria: {
          ...prevState.matching_criteria,
          meeting_days: [...prevState.matching_criteria.meeting_days, value],
        },
        meetingDaysError: "",
      }));
    }
  }

  //updated
  handleTimeSlotOnChange(index, meetingDay) {
    this.setState((prevState) => ({
      matching_criteria: {
        ...prevState.matching_criteria,
        meeting_days: [
          ...prevState.matching_criteria.meeting_days.map((d, i) => {
            if (i === index) {
              return meetingDay;
            } else {
              return d;
            }
          }),
        ],
      },
    }));
  }

  //updated
  handleDeleteTimeSlot(index) {
    let meetingDays = [...this.state.matching_criteria.meeting_days];
    if (meetingDays.length < 5) {
      this.setState({
        meetingDaysError: "",
      });
    }
    meetingDays.splice(index, 1);
    this.setState((prevState) => ({
      matching_criteria: {
        ...prevState.matching_criteria,
        meeting_days: meetingDays,
      },
    }));
  }

  //updated
  handleMeetingSchedulerOnChange(e) {
    this.setState((prevState) => ({
      matching_criteria: {
        ...prevState.matching_criteria,
        account_links: {
          ...prevState.matching_criteria.account_links,
          meeting_scheduler: e.target.value,
        },
      },
    }));
  }

  //updated
  handleLinkedInOnChange(e) {
    this.setState((prevState) => ({
      matching_criteria: {
        ...prevState.matching_criteria,
        account_links: {
          ...prevState.matching_criteria.account_links,
          linkedin: e.target.value,
        },
      },
    }));
  }

  //updated
  handleWebsiteOnChange(e) {
    this.setState((prevState) => ({
      matching_criteria: {
        ...prevState.matching_criteria,
        account_links: {
          ...prevState.matching_criteria.account_links,
          company_website: e.target.value,
        },
      },
    }));
  }

  //TODO
  handleSaveMatchingChanges() {
    let matching_criteria = { ...this.state.matching_criteria };
    if (
      matching_criteria.industry !== "" &&
      matching_criteria.industry_importance !== "" &&
      matching_criteria.revenue_range !== "" &&
      matching_criteria.match_comparable_revenues !== "" &&
      matching_criteria.nearest_business_goal !== "" &&
      matching_criteria.growth_goal_match !== "" &&
      matching_criteria.meeting_days.length > 0
    ) {
      call.users_API
        .getPersonalUserMatchingCriteria()
        .then((result) => {
          if (result.success) {
            let matching_data = result.results.matching_data;
            //user has matching criteria => update
            if (matching_data) {
              this.setState({
                formError: "",
              });
              call.matching_criteria_API
                .updateMatchingCriteria(matching_criteria)
                .then((result) => {
                  if (result.success) {
                    this.props.showSuccessBox(
                      "Success",
                      "Your data has been saved!"
                    );
                  } else {
                    this.props.history.push("/error", {
                      error: result.results,
                    });
                  }
                })
                .catch((err) => {
                  this.props.history.push("/error", { error: err.message });
                });
              //user doesnt have matching criteria => create
            } else {
              this.setState({
                formError: "",
              });
              call.matching_criteria_API
                .createMatchingCriteria(matching_criteria)
                .then((result) => {
                  if (result.success) {
                    this.props.showSuccessBox(
                      "Success",
                      "Your data has been saved!"
                    );
                  } else {
                    this.props.history.push("/error", {
                      error: result.results,
                    });
                  }
                })
                .catch((err) => {
                  this.props.history.push("/error", { error: err.message });
                });
            }
          } else {
            this.props.history.push("/error", { error: result.results });
          }
        })
        .catch((err) => {
          this.props.history.push("/error", { error: err.message });
        });
    } else {
      this.props.showErrorBox(
        "Error",
        "Make sure to complete required fields."
      );
    }

    //
    //
  }

  render() {
    return (
      <form onSubmit={(e) => e.preventDefault()}>
        {this.state.formError !== "" ? (
          <div className="save-error">
            <InputErrorMessage errorText={this.state.formError} />
          </div>
        ) : null}
        <FormContainer containerClass="industry" formTitle="Industry">
          <div className="rounded-sub-form">
            <label>Which industry most closely matches yours?</label>
            {/* <SelectInput
              data={Industries}
              name="industry"
              inputValue={this.state.matching_criteria.industry}
              placeholder="Choose industry..."
              handleOnChangeValue={this.handleOnIndustryChange}
              inputId="industry-input"
              optionsId="industry-options"
              zIndexValue={1}
            /> */}
            <MultiSelectCheckbox
              data={Industries}
              name="industry_choice"
              checkedValues={this.state.matching_criteria.industry}
              placeholder="Choose industry..."
              zIndexValue={5}
              inputName="industry"
              handleCheckboxOnChange={this.handleOnIndustryChange}
              keyword="industries"
            />
          </div>
          <div className="rounded-sub-form">
            <label>
              How important is that you match with others from your industry?
            </label>
            <RadioInput
              data={IndustryMatchImportance}
              name="matching-industry"
              incomingValue={this.state.matching_criteria.industry_importance}
              onChange={this.handleIndustryImportanceOnChange}
              inputId="revenue-input"
              optionsId="revenue-options"
            />
          </div>
        </FormContainer>
        <FormContainer containerClass="revenue" formTitle="Revenue">
          <div className="rounded-sub-form">
            <label>About how much does your business generate each year?</label>
            <SelectInput
              data={Revenue}
              name="revenue"
              inputValue={this.state.convertedRevenue}
              placeholder="Choose revenue..."
              handleOnChangeValue={this.handleRevenueOnChange}
              zIndexValue={1}
            />
          </div>
          <div className="rounded-sub-form">
            <label>
              How important is that you match with others with comparable
              revenues?
            </label>
            <RadioInput
              data={RevenueMatchImportance}
              name="matching-revenue"
              incomingValue={
                this.state.matching_criteria.match_comparable_revenues
              }
              onChange={this.handleRevenueImportanceOnChange}
            />
          </div>
        </FormContainer>
        <FormContainer
          containerClass="business-goals"
          formTitle="Business goals"
        >
          <div className="rounded-sub-form">
            <label>What's your nearest business goal?</label>
            <SelectInput
              data={BusinessGoal}
              name="business-goal"
              inputValue={this.state.matching_criteria.nearest_business_goal}
              placeholder="Choose business goal..."
              handleOnChangeValue={this.hanldeOnBusinessGoalChange}
              inputId="business-goal-input"
              optionsId="business-goal-options"
              zIndexValue={1}
            />
          </div>
          <div className="rounded-sub-form">
            <label>
              How important is that you match with others who share your
              business goal?
            </label>
            <RadioInput
              data={GoalMatchImportance}
              name="business-goal"
              incomingValue={this.state.matching_criteria.growth_goal_match}
              onChange={this.handleOnBusinessGoalImportanceChange}
              inputId="growth-match-input"
              optionsId="growth-match-options"
            />
          </div>
        </FormContainer>
        <FormContainer containerClass="availability" formTitle="Availability">
          <div className="rounded-sub-form">
            <TimeSlotHandler
              meetingDays={this.state.matching_criteria.meeting_days}
              handleTimeSlotOnChange={this.handleTimeSlotOnChange}
              handleDeleteTimeSlot={this.handleDeleteTimeSlot}
            />
          </div>
          <div className="rounded-sub-form">
            {this.state.meetingDaysError ? (
              <InputErrorMessage errorText={this.state.meetingDaysError} />
            ) : null}

            <TimeSetter handleAddingTimeSlot={this.handleAddingTimeSlot} />
          </div>
        </FormContainer>
        <FormContainer
          containerClass="scheduling-links"
          formTitle="Scheduling Links"
        >
          <div className="rounded-sub-form">
            <TextInput
              type="text"
              id="meeting-scheduler"
              value={
                this.state.matching_criteria.account_links.meeting_scheduler
              }
              handleTextInputOnChange={this.handleMeetingSchedulerOnChange}
              label="Do you use a meeting scheduler (ie. Calendly)? If so, what's your link?"
              placeholder="Meeting scheduler link"
            />

            <TextInput
              type="text"
              id="linkedin"
              value={this.state.matching_criteria.account_links.linkedin}
              handleTextInputOnChange={this.handleLinkedInOnChange}
              label="What's your LinkedIn profile URL?"
              placeholder="Linkedin profile link"
            />

            <TextInput
              type="text"
              id="company-website"
              value={this.state.matching_criteria.account_links.company_website}
              handleTextInputOnChange={this.handleWebsiteOnChange}
              label="Do you have a company website?"
              placeholder="Company website URL"
            />
          </div>
        </FormContainer>
        <PrimaryButton
          primaryButtonText="Save changes"
          handlePrimaryBtnOnClick={this.handleSaveMatchingChanges}
        />
      </form>
    );
  }
}

export default withRouter(MatchingForm);
